import { gtm } from './gtm.js';

export function initAccomodationContactForm() {
    const contactBtn = document.querySelector( '[data-target="contact-information"]' );
    if ( contactBtn ) {
        const contactPanel = document.querySelector( '.contact-information' );
        contactBtn.addEventListener( 'click', () => {
            contactPanel.classList.toggle( 'is-visible' );
            gtm.presoContatti( {
                accommodation_id   : contactBtn.dataset.accId   || '',
                accommodation_name : contactBtn.dataset.accName || '',
            } );
        } );
    }

    const form = document.getElementById( 'accommodation-form' );
    if ( ! form ) return;

    const lang        = form.dataset.lang;
    const owner       = form.dataset.owner;
    const postId      = form.dataset.post;
    const title       = form.dataset.title;
    const destination = form.dataset.destination;

    const fields = {
        fullname  : form.querySelector( '#acc_fullname' ),
        email     : form.querySelector( '#acc_email' ),
        telephone : form.querySelector( '#acc_telephone' ),
        checkin   : form.querySelector( '#acc_checkin' ),
        checkout  : form.querySelector( '#acc_checkout' ),
        persons   : form.querySelector( '#acc_persons' ),
        rooms     : form.querySelector( '#acc_rooms' ),
        childrens : form.querySelector( '#acc_childrens' ),
        notes     : form.querySelector( '#acc_notes' ),
        auth      : form.querySelector( '#acc_auth' ),
    };

    const inputsFields = form.querySelector( '.sk-inputs-fields' );
    const loader       = form.querySelector( '.sk-form-loader' );
    const msgError     = form.querySelector( '.f-output.f-error' );
    const msgSuccess   = form.querySelector( '.f-output.f-success' );
    const submitBtn    = form.querySelector( '.btn-submit-accommodation' );

    // Enforce today as min date for check-in, and keep check-out after check-in.
    const today = new Date().toISOString().split( 'T' )[0];
    fields.checkin.min = today;

    fields.checkin.addEventListener( 'change', () => {
        if ( fields.checkin.value ) {
            const nextDay = new Date( fields.checkin.value );
            nextDay.setDate( nextDay.getDate() + 1 );
            fields.checkout.min = nextDay.toISOString().split( 'T' )[0];

            if ( fields.checkout.value && fields.checkout.value <= fields.checkin.value ) {
                fields.checkout.value = nextDay.toISOString().split( 'T' )[0];
            }
        }
    } );

    submitBtn.addEventListener( 'click', () => {
        hideMessages();

        if ( ! validate() ) {
            showLoader( false );
            showMessage( msgError );
            return;
        }

        gtm.formBookingSubmit( {
            accommodation_id          : postId,
            accommodation_name        : title,
            accommodation_destination : destination,
            checkin                   : fields.checkin.value,
            checkout                  : fields.checkout.value,
            persons                   : fields.persons.value,
        } );

        showLoader( true );
        inputsFields.classList.add( 'is-load' );

        const body = new URLSearchParams( {
            action        : 'sk_accommodation_contact_action',
            a_lang        : lang,
            a_owner       : owner,
            a_postid      : postId,
            a_destination : destination,
            a_title       : title,
            a_fullname    : fields.fullname.value,
            a_email       : fields.email.value,
            a_telephone   : fields.telephone.value,
            a_checkin     : fields.checkin.value,
            a_checkout    : fields.checkout.value,
            a_persons     : fields.persons.value,
            a_rooms       : fields.rooms.value,
            a_childrens   : fields.childrens.value,
            a_notes       : fields.notes.value,
        } );

        fetch( lbhAjax.url, { method: 'POST', body } )
            .then( () => {
                gtm.formBookingSuccess( {
                    accommodation_id          : postId,
                    accommodation_name        : title,
                    accommodation_destination : destination,
                    checkin                   : fields.checkin.value,
                    checkout                  : fields.checkout.value,
                    persons                   : fields.persons.value,
                } );
                resetForm();
                showMessage( msgSuccess );
                setTimeout( () => hideMessages(), 4000 );
            } )
            .catch( () => showMessage( msgError ) )
            .finally( () => {
                showLoader( false );
                inputsFields.classList.remove( 'is-load' );
            } );
    } );

    function validate() {
        let valid = true;

        form.querySelectorAll( '.sk-req' ).forEach( el => {
            el.classList.remove( 'f-required' );

            const empty = el.type === 'checkbox' ? ! el.checked : ! el.value.trim();
            if ( empty ) {
                el.classList.add( 'f-required' );
                valid = false;
            }
        } );

        return valid;
    }

    function resetForm() {
        form.querySelectorAll( 'input:not([type="checkbox"]), select, textarea' )
            .forEach( el => ( el.value = '' ) );
        if ( fields.auth ) fields.auth.checked = false;
    }

    function showLoader( show ) {
        loader.classList.toggle( 'is-visible', show );
    }

    function showMessage( el ) {
        el.classList.add( 'is-visible' );
    }

    function hideMessages() {
        msgError.classList.remove( 'is-visible' );
        msgSuccess.classList.remove( 'is-visible' );
    }
}
